<div class="bg-white p-4 flex flex-col items-center justify-center">

    <div class="flex justify-center items-center" style="margin-bottom: 40px;">
        <div class="mr-4 text-right text-lg flex justify-end" [ngClass]="{'font-bold': isSequential}"
            style="width: 200px;">
            <div class="flex justify-center items-center mr-4 relative">
                <div *ngIf="showSequentialDescription"
                    class="p-4 absolute text-center border bg-white rounded-lg flex flex-col items-center justify-center"
                    style="width: 400px; z-index: 10; bottom: 28px; border-color: black;">
                    <div class="absolute border-r border-b bg-white rotate-45"
                        style="bottom: -8px; height: 16px; width: 16px; z-index: 20; border-color: black;"></div>
                    <span class="font-normal text-sm">
                        <span>Sequential retention requires players to play each sequential game.</span>
                        <br /><br />
                        <span>Example, a player enters game 1, misses game 2, and enters game 3: this player would not
                            be considered 'retained' from game 1 to game 3.</span>
                    </span>
                </div>
                <span class="icon ng-icon-info-filled" style="line-height: unset; color: #2196F3;"
                    (mouseenter)="showSequentialDescription = true"
                    (mouseout)="showSequentialDescription = false"></span>
            </div>
            <div>Sequential</div>
        </div>
        <label class="switch">
            <input type="checkbox" [(ngModel)]="isSequential" (change)="buildRetentionMatrix()">
            <span class="slider round"></span>
        </label>
        <div class="ml-4 text-left text-lg flex" [ngClass]="{'font-bold': !isSequential}" style="width: 200px;">
            <div>Relative to first</div>
            <div class="flex justify-center items-center ml-4 relative">
                <div *ngIf="showRelativeToFirstDescription"
                    class="p-4 absolute text-center border bg-white rounded-lg flex flex-col items-center justify-center"
                    style="width: 400px; z-index: 10; bottom: 28px; border-color: black;">
                    <div class="absolute border-r border-b bg-white rotate-45"
                        style="bottom: -8px; height: 16px; width: 16px; z-index: 20; border-color: black;"></div>
                    <span class="font-normal text-sm">
                        <span>Relative to first retention doesn't require players to play each sequential game.</span>
                        <br /><br />
                        <span>Example, a player enters game 1, misses game 2, and enters game 3: this player would be
                            considered 'retained' from game 1 to game 3.</span>
                    </span>
                </div>
                <span class="icon ng-icon-info-filled" style="line-height: unset; color: #08ae1e;"
                    (mouseenter)="showRelativeToFirstDescription = true"
                    (mouseout)="showRelativeToFirstDescription = false"></span>
            </div>
        </div>
    </div>

    <button
        class="items-center h-10 w-48 justify-center rounded border border-transparent bg-indigo-600 p-2 text-sm font-medium text-white"
        (click)="generateTable()" [disabled]="isButtonDisabled()">{{hasBuiltMatrix ? 'Refresh' : 'Generate'}}</button>

    <div *ngIf="buildingMatrix === false" class="flex flex-col items-center" style="width: 70%;">
        <div class="relative flex flex-col items-start w-full my-8" *ngFor="let x of blob | keyvalue; let j = index">
            <h1 class="text-lg font-semibold">{{x.key}}</h1>
            <table class="retention-table">
                <thead>
                    <div class="flex flex-col">
                        <div class="flex" *ngIf="filteredByCompetition">
                            <div *ngFor="let gameId of x.value.gameIds; let idx = index" class="flex justify-center items-center font-medium relative" style="min-width: 150px; height: 30px;" 
                                [ngStyle]="{'border-left': (idx > 0 && x.value.gameIdToRoundName[gameId] !== x.value.gameIdToRoundName[x.value.gameIds[idx - 1]]) ? '1px solid #dddddd' : 'none', 'border-right': (idx < (x.value.gameIds.length - 1) && x.value.gameIdToRoundName[gameId] !== x.value.gameIdToRoundName[x.value.gameIds[idx + 1]]) ? '1px solid #dddddd' : 'none'}">
                                <div *ngIf="(idx < (x.value.gameIds.length - 1) && x.value.gameIdToRoundName[gameId] !== x.value.gameIdToRoundName[x.value.gameIds[idx + 1]]) || (idx === (x.value.gameIds.length - 1))" class="absolute flex justify-center" style="width: 150px;" [ngStyle]="{'right': 50 * (getNumberOfGamesInRound(x.key, gameId) - 1) + '%'}">
                                    {{x.value.gameIdToRoundName[gameId]}}
                                </div>
                            </div>
                        </div>
                        <div class="flex">
                            <ng-container *ngFor="let gameId of x.value.gameIds; let idx = index">
                                <th>
                                    <div>{{x.value[gameId].name}}</div>
                                    <div *ngIf="idx < x.value.gameIds.length - 1">%</div>
                                </th>
                            </ng-container>
                        </div>
                    </div>
                    <div class="flex flex-col absolute" style="right: 0;">
                        <div class="flex" *ngIf="filteredByCompetition" style="height: 30px;"></div>
                        <th>
                            <div>Average %</div>
                        </th>
                    </div>
                    
                </thead>
                <tbody>
                    <ng-container *ngFor="let gameId of x.value.gameIds; let idx = index">
                        <tr>
                            <ng-container *ngFor="let i of [].constructor(idx)">
                                <td style="border: none;">
                                    <div></div>
                                    <div style="border: none;"></div>
                                </td>
                            </ng-container>
                            <ng-container
                                *ngFor="let retainedPlayers of x.value[gameId].retainedPlayers; let idx2 = index">
                                <td [ngStyle]="{'background-color': 'hsl(' + colourDegrees[idx2] + ' 50 50 / 50%)'}">
                                    <div class="relative">
                                        {{retainedPlayers}}
                                        <div *ngIf="selectedGameTypeId > 0 && idx2 === 0 && idx > 0" class="absolute"
                                            style="bottom: -6px; left: -1px; font-weight: 800;"
                                            [ngStyle]="{'color': getDifferenceInRetainedPlayers(x.key, idx, idx2) < 0 ? 'red' : getDifferenceInRetainedPlayers(x.key, idx, idx2) === 0 ? 'grey' : 'green'}">
                                            {{getDifferenceInRetainedPlayersFormatted(x.key, idx, idx2)}}
                                        </div>
                                    </div>
                                    <div *ngIf="idx2 < x.value.gameIds.length - idx - 1">{{
                                        getPercentage(x.value[x.value.gameIds[idx]].retainedPlayers[idx2 + 1],
                                        x.value[x.value.gameIds[idx]].retainedPlayers[0]) }}</div>
                                </td>
                                <td *ngIf="isFinalColumn(idx2, x.value[gameId].retainedPlayers)" class="absolute"
                                    style="right: 0;"
                                    [ngStyle]="{'background-color': idx === 0 ? 'white' : 'hsl(' + colourDegrees[idx2 + 1] + ' 50 50 / 50%)'}">
                                    <div>{{ getAveragePercentage(x.key, idx, idx2 + 1) }}</div>
                                </td>
                            </ng-container>
                        </tr>
                    </ng-container>
                    <tr>
                        <ng-container *ngFor="let i of [].constructor(x.value.gameIds.length)">
                            <td style="border: none;">
                                <div style="height: 21px;"></div>
                                <div style="border: none;"></div>
                            </td>
                        </ng-container>
                        <td class="absolute" style="right: 0;"
                            [ngStyle]="{'background-color': 'hsl(' + colourDegrees[0] + ' 50 50 / 50%)'}">
                            <div>{{ getAveragePercentage(x.key, x.value.gameIds.length, 0) }}</div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="absolute"
                style="width: 1px; height: 100%; border-right: 1px dashed #dddddd; right: 155px; top: 24px;"
                [ngStyle]="{'height': isFinalBlob(j) ? '100%' : 'calc(100% + 62px)'}"></div>
        </div>

    </div>
</div>